export const DEFAULT_PAGE_SIZE = 10
export const INITIAL_PAGE = 1
export const DEBOUNCE_DELAY = 500
